import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useFetchUser from 'src/Hooks/Queries/useFetchUser';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './HomeToDoLine.module.scss';
import { Props } from './HomeToDoLine.types';

const HomeToDoLine = ({ overdueTasks, pendingVotes, statementsToSend }: Props) => {
  const { t } = useTranslation();
  const { data: me } = useFetchUser();
  const assetId = useCurrentAssetId();

  const firstName = me?.firstName?.trim() ?? '';
  const hello = firstName
    ? t('dashboard.todo.hello', 'Bonjour {{name}}', { name: firstName })
    : t('dashboard.todo.helloAnon', 'Bonjour');

  const nothingLeft = overdueTasks === 0 && pendingVotes === 0 && (statementsToSend ?? 0) === 0;

  if (nothingLeft) {
    return (
      <div className={styles.container}>
        <span>{hello}</span>
        <span className={styles.allDone}>{t('dashboard.todo.allDone', 'Tout est à jour ✓')}</span>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <span>{hello} —</span>
      {overdueTasks > 0 && (
        <Link to={`/asset/${assetId}/tasks`} className={styles.counter}>
          {t('dashboard.todo.overdueTasks', {
            defaultValue: '{{count}} tâche en retard',
            defaultValue_other: '{{count}} tâches en retard',
            count: overdueTasks,
          })}
        </Link>
      )}
      {pendingVotes > 0 && (
        <Link to={`/asset/${assetId}/project-and-works`} className={styles.counter}>
          {t('dashboard.todo.pendingVotes', {
            defaultValue: '{{count}} vote en attente',
            defaultValue_other: '{{count}} votes en attente',
            count: pendingVotes,
          })}
        </Link>
      )}
      {statementsToSend != null && statementsToSend > 0 && (
        <Link to={`/asset/${assetId}/expenses`} className={styles.counter}>
          {t('dashboard.todo.statementsToSend', {
            defaultValue: '{{count}} relevé à envoyer',
            defaultValue_other: '{{count}} relevés à envoyer',
            count: statementsToSend,
          })}
        </Link>
      )}
    </div>
  );
};

export default HomeToDoLine;
